// Shared motion constants for the Daten-Bot widget's chrome. Hoisted from
// BotLauncher.tsx / BotPanel.tsx / avatar/LogoAvatar.tsx, which each
// hardcoded the identical literal — a future tweak to the chrome-transition
// feel now only needs to change one place.

/** DESIGN.md §14 spring physics for chrome interactions. */
export const CHROME_SPRING = { type: 'spring', stiffness: 120, damping: 20 } as const
